import "./styles.css";
import { trackConversion } from "./analytics";

const form = document.querySelector<HTMLFormElement>("#waitlist-form");
const email = document.querySelector<HTMLInputElement>("#email");
const status = document.querySelector<HTMLParagraphElement>("#form-status");

function showStatus(message: string, state: "success" | "error" | "pending" = "pending"): void {
  if (!status) return;
  status.textContent = message;
  status.dataset.state = state;
}

if (form && email) {
  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    trackConversion("waitlist_view");
    observer.disconnect();
  }, { threshold: 0.25 });
  observer.observe(form);

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    const normalizedEmail = email.value.trim();
    if (!email.validity.valid || !normalizedEmail) {
      email.setAttribute("aria-invalid", "true");
      showStatus("Enter a valid email address.", "error");
      email.focus();
      return;
    }
    email.removeAttribute("aria-invalid");
    const submit = form.querySelector<HTMLButtonElement>("button[type=submit]");
    submit?.setAttribute("disabled", "true");
    showStatus("Sending your request…");
    trackConversion("waitlist_submit");
    try {
      const response = await fetch("/api/waitlist", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: normalizedEmail }),
      });
      const body = await response.json().catch(() => null) as { ok?: boolean; message?: string; error?: string } | null;
      if (response.status !== 202 || !body?.ok) {
        showStatus(body?.error || "Waitlist signup is unavailable right now. Please try again shortly.", "error");
        trackConversion("waitlist_error", response.status);
        return;
      }
      email.value = "";
      showStatus(body.message || "Thanks — we received your waitlist request.", "success");
      trackConversion("waitlist_success", response.status);
    } catch {
      showStatus("Waitlist signup is unavailable right now. Please try again shortly.", "error");
      trackConversion("waitlist_error");
    } finally {
      submit?.removeAttribute("disabled");
    }
  });
}
